export const spreadObject = (obj1, obj2) => {
  const newObj = {}
  for (const [key, value] of Object.entries(obj1)) {
    if (typeof obj1[key] === 'object' && !Array.isArray(obj1[key]) && obj1[key] !== null)
      newObj[key] = { ...obj1[key], ...obj2[key] }
  }
  return newObj
}
